import { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { CepSteps, TacticMode } from 'basics/enums/maya.enums';
import { CepStateType } from 'basics/types/maya.types';
import cepState from 'states/cep.states';
import dropMaterials from 'states/dropMaterials.states';
import tacticState from 'states/tactic.states';
import { useYodaForm } from 'yoda-ui/yodaForm';

const useTacticsStep = () => {
  const { useWatchStep } = useYodaForm();
  const stepState = useWatchStep(CepSteps.tacticsStep);
  const cepStateValue = useSnapshot(cepState) as CepStateType;

  useEffect(() => {
    tacticState.cepId = cepStateValue.cep?._id || '';
    tacticState.tactic = null;
    tacticState.mode = TacticMode.list;
  }, [cepStateValue.cep?._id]);

  useEffect(() => {
    return function cleanup() {
      tacticState.cepId = '';
      tacticState.tactic = null;
      tacticState.mode = TacticMode.list;
      dropMaterials.dropMaterials = [];
      dropMaterials.isLoaded = false;
    };
  }, []);

  const handleTacticDialogClose = () => {
    tacticState.tactic = null;
    tacticState.mode = TacticMode.list;
  };

  return {
    stepIsValid: stepState?.isValid || false,
    handleTacticDialogClose,
  };
};

export default useTacticsStep;
